module.exports = __webpack_public_path__ + "img/SKMJ_grinder3.ea6032a2.jpg";